export default __webpack_public_path__ + "static/media/transparent-dark-blue-ph-spinner.f5312f71.gif";